module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/plugin-gotenehus-product-regions/plugin-gotenehus-product-regions.component.scss
// module id = ./src/app/pages/plugin-gotenehus-product-regions/plugin-gotenehus-product-regions.component.scss
// module chunks = main